<template>
  <loading-cmp />
  <router-view />
</template>

<style scoped lang="postcss">
:deep(.sf-btn-primary) {
  @apply hover:tw-outline-[2px] focus:tw-text-mainbg1 focus:tw-outline-mainbg1;
}

:deep(.sf-btn-secondary) {
  @apply hover:tw-outline-[2px] focus:tw-text-primary focus:tw-outline-primary focus:tw-border-mainbg1;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import LoadingCmp from './components/ui/LoadingCmp.vue';

export default defineComponent({
  components: { LoadingCmp },
});

</script>